import { render, staticRenderFns } from "./RectifierOrdersBoard.vue?vue&type=template&id=54f3828c"
import script from "./RectifierOrdersBoard.vue?vue&type=script&lang=js"
export * from "./RectifierOrdersBoard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./resources/locales.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fgithub%2Fworkspace%2Fsrc%2Fviews%2Forder%2Forders-boards%2Frectifier-board%2FRectifierOrdersBoard.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports